enum API {
  // 后台用户相关
  loginByEmail = '/manage/platform/loginByEmail', // 平台账号登录
  loginByAccount = '/manage/platform/loginByAccount', // 平台账号登录
  loginOut = '/manage/platform/loginOut', // 平台账号退出登录
  updatePlatformAccountPassword = '/manage/platform/updatePlatformAccountPassword', // 修改密码（平台登录账号）
  queryPlatformAccountList = '/manage/platform/queryPlatformAccountList', // 查询平台账号列表
  createPlatformAccount = '/manage/platform/createPlatformAccount', // 创建平台登录账号
  resetPasswordsForPlatformAccount = '/manage/platform/resetPasswordsForPlatformAccount', // 重置密码（平台端）
  getCurrentPlatform = '/manage/platform/getCurrentPlatform', // 获取当前登录账号信息
  updatePlatformAccount = '/manage/platform/updatePlatformAccount', // 修改信息（平台登录账号）

  // 渠道
  queryUserChannelList = '/manage/channel/queryUserChannelList', // 查询渠道列表
  createUserChannel = '/manage/channel/createUserChannel', // 创建渠道
  updateUserChannel = '/manage/channel/updateUserChannel', // 修改渠道
  deleteUserChannel = '/manage/channel/deleteUserChannel', // 删除渠道

  // 文件上传
  fileUpload = '/fileupload/fileUpload', // 文件上传

  // 户主
  queryHouseList = '/manage/house/queryHouseList', // 查询房子信息列表
  queryHouseByCode = '/manage/house/queryHouseByCode', // 通过编号查询房子信息
  createHouseInfo = '/manage/house/createHouseInfo', // 创建房子信息
  updateHouseInfo = '/manage/house/updateHouseInfo', // 更新房子信息
  importGoodsData = '/manage/house/importGoodsData', // 导入房子信息
  barchCreateHouseInfo = '/manage/house/barchCreateHouseInfo', // 批量创建房子信息（配合导入房子信息接口使用）

  // 用户
  queryUserList = '/manage/user/queryUserList', // 查询用户信息列表
  exportUserList = '/manage/user/exportUserList', // 用户列表导出
  queryShopUserList = '/manage/user/queryShopUserList', // 查询店铺用户信息列表
  queryUserById = '/manage/user/queryUserById', // 查询用户信息
  updateInfo = '/manage/user/updateInfo', // 更新用户信息(角色)
  updateUserInfoRole = '/manage/user/updateUserInfoRole', // 更新用户身份
  updateUserInfoWealth = '/manage/user/updateUserInfoWealth', // 更新用户财富
  manualAdjustUserFrozenPoints = '/manage/user/manualAdjustUserFrozenPoints', // 手动调整用户积分余额
  freezeUser = '/manage/user/freezeUser', // 冻结用户（清登录）
  unfreezeUser = '/manage/user/unfreezeUser', // 解冻用户
  updateUserInviteInfo = '/manage/user/updateUserInviteInfo', // 修改用户推荐人
  createUserInfo = '/manage/user/createUserInfo', // 创建用户

  mungBeanAllocatePreview = '/manage/mungBeanAllocate/preview', // 分配型绿豆充值-试算
  mungBeanAllocateExecute = '/manage/mungBeanAllocate/execute', // 分配型绿豆充值-执行
  mungBeanAllocateBatchList = '/manage/mungBeanAllocate/batchList', // 分配型绿豆充值-批次列表
  mungBeanAllocateBatchDetail = '/manage/mungBeanAllocate/batchDetail', // 分配型绿豆充值-批次详情
  mungBeanAllocateDetailList = '/manage/mungBeanAllocate/detailList', // 分配型绿豆充值-分配明细
  mungBeanAllocateSedimentList = '/manage/mungBeanAllocate/sedimentList', // 分配型绿豆充值-沉淀记录

  specialPricePoolBalances = '/manage/specialPrice/poolBalances', // 特价池余额
  specialPricePoolRecordList = '/manage/specialPrice/poolRecordList', // 特价池流水
  specialPricePoolAdjust = '/manage/specialPrice/poolAdjust', // 特价池手工调账
  specialPriceOrderAllocateList = '/manage/specialPrice/orderAllocateList', // 特价订单分配列表
  specialPriceOrderAllocateDetail = '/manage/specialPrice/orderAllocateDetail', // 特价订单分配详情

  // 商品
  queryGoodsList = '/manage/goods/queryGoodsList', // 查询商品信息列表
  queryGoodsCounts = '/manage/goods/queryGoodsCounts', // 查询商品数量统计
  exportGoods = '/manage/goods/exportGoods', // 商品导出
  queryGoodsByCodee = '/manage/goods/queryGoodsByCodee', // 通过Codee查询
  careateGoods = '/manage/goods/careateGoods', // 创建商品
  updateGoods = '/manage/goods/updateGoods', // 修改商品
  deleteGoods = '/manage/goods/deleteGoods', // 删除商品
  updateGoodsStatus = '/manage/goods/updateGoodsStatus', // 商品上架/下架
  updateGoodsMian = '/manage/goods/updateGoodsMian', // 商品免单/免单2
  batchUpdateGoodsStatus = '/manage/goods/batchUpdateGoodsStatus', // 商品上架/下架
  batchDeleteGoods = '/manage/goods/batchDeleteGoods', // 商品批量删除
  goodsAuditPass = '/manage/goods/goodsAuditPass', // 商品审核通过
  goodsAuditReject = '/manage/goods/goodsAuditReject', // 商品审核驳回
  batchRemoveIndexGoods = '/manage/goods/batchRemoveIndexGoods', // 批量移除首页商品
  batchAddIndexGoods = '/manage/goods/batchAddIndexGoods', // 批量添加首页商品
  batchRemovePaymentDiscountGoods = '/manage/goods/batchRemovePaymentDiscountGoods', // 批量添加支付立减商品
  batchAddPaymentDiscountGoods = '/manage/goods/batchAddPaymentDiscountGoods', // 批量添加支付立减商品

  // 一县一特商品
  queryCityGoodsList = '/manage/cityGoods/queryCityGoodsList', // 查询城市商品信息
  queryEachCityGoodsCount = '/manage/cityGoods/queryEachCityGoodsCount', // 查询每个城市绑定的商品信息
  batchAddCityGoods = '/manage/cityGoods/batchAddCityGoods', // 批量添加城市商品
  batchDeleteCityGoods = '/manage/cityGoods/batchDeleteCityGoods', // 批量删除城市商品

  // 一县一特-分类
  queryCityClassifyTree = '/manage/cityClassify/queryCityClassifyTree', // 查询城市分类树
  queryCityClassifyList = '/manage/cityClassify/queryCityClassifyList', // 查询城市分类列表
  addCityClassify = '/manage/cityClassify/addCityClassify', // 添加城市分类
  updateCityClassify = '/manage/cityClassify/updateCityClassify', // 修改城市分类
  deleteCityClassify = '/manage/cityClassify/deleteCityClassify', // 删除城市分类

  // 活动
  queryActivityList = '/manage/activity/queryActivityList', // 查询活动列表
  createActivity = '/manage/activity/createActivity', // 创建活动
  updateActivity = '/manage/activity/updateActivity', // 修改活动
  deleteActivity = '/manage/activity/deleteActivity', // 删除活动
  queryActivityGoodsList = '/manage/activity/queryActivityGoodsList', // 查询活动商品列表
  queryActivityGoodsAllList = '/manage/activity/queryActivityGoodsAllList', // 查询活动商品列表(已活动商品为主)
  addActivityGoods = '/manage/activity/addActivityGoods', // 添加活动商品
  batchAddActivityGoods = '/manage/activity/batchAddActivityGoods', // 批量添加活动商品
  updateActivityGoods = '/manage/activity/updateActivityGoods', // 修改活动商品
  deleteActivityGoods = '/manage/activity/deleteActivityGoods', // 删除活动商品
  batchDeleteActivityGoods = '/manage/activity/batchDeleteActivityGoods', // 删除活动商品
  queryActivityAllList = '/manage/activity/queryAllList', //查询全部活动商品

  // 分类
  queryClassifyTree = '/manage/classify/queryClassifyTree', // 查询商品信息列表
  createClassify = '/manage/classify/createClassify', // 创建分类
  updateClassify = '/manage/classify/updateClassify', // 更新分类
  deleteClassify = '/manage/classify/deleteClassify', // 删除分类
  saveClassifySort = '/manage/classify/saveClassifySort', // 保存分类排序

  // 订单
  queryOrderInfoList = '/manage/order/queryOrderInfoList', // 查询订单列表
  queryAfterSaleRefundList = '/manage/order/queryAfterSaleRefundList', // 售后/退款：zy_order_refund 分页
  queryOrderInfoCounts = '/manage/order/queryOrderInfoCounts', // 查询各订单分类数量
  querySettlementOrderCounts = '/manage/order/querySettlementOrderCounts', // 查询各结算订单分类数量
  queryOrderInfoByCode = '/manage/order/queryOrderInfoByCode', // 通过订单编号，获取订单信息
  queryOrderGoodsDescList = '/manage/order/queryOrderGoodsDescList', // 查询订单商品明细列表
  listJkySyncLogByOrderCode = '/manage/order/listJkySyncLogByOrderCode', // 订单吉客云日志
  queryOrderWealthDetail = '/manage/order/queryOrderWealthDetail', // 订单财富明细
  confirmOrder = '/manage/order/confirmOrder', // 确认订单
  deliveryOrder = '/manage/order/deliveryOrder', // 订单发货
  updateExpressOrder = '/manage/order/updateExpressOrder', // 更新物流单号
  refusedOrder = '/manage/order/refusedOrder', // 拒绝订单
  batchConfirmOrder = '/manage/order/batchConfirmOrder', // 批量确认订单
  batchDeliveryOrder = '/manage/order/batchDeliveryOrder', // 批量订单发货
  confirmRefund = '/manage/order/confirmRefund', // 确认退款
  previewRefundPostProcessCorrection = '/manage/order/previewRefundPostProcessCorrection', // 退款后置补正预览
  applyRefundPostProcessCorrection = '/manage/order/applyRefundPostProcessCorrection', // 退款后置补正执行
  batchPreviewRefundPostProcessCorrection = '/manage/order/batchPreviewRefundPostProcessCorrection', // 批量退款后置补正预览
  batchApplyRefundPostProcessCorrection = '/manage/order/batchApplyRefundPostProcessCorrection', // 批量退款后置补正执行
  confirmReturnRefundAfterLogistics = '/manage/order/confirmReturnRefundAfterLogistics', // 退货退款：物流中/已签收后确认打款
  cancelRefund = '/manage/order/cancelRefund', // 取消退款
  sumOrderShopData = 'manage/order/sumOrderShopData', // 取消退款
  sumShopOrderReport = '/manage/shop/sumShopOrderReport', // 取消退款
  queryShopOrderReportList = '/manage/shop/queryShopOrderReportList', // 取消退款
  exportOrder = '/manage/order/exportOrder', // 订单导出
  exportSettlementOrder = '/manage/order/exportSettlementOrder', // 结算订单导出
  updateDeliveryType = '/manage/order/updateDeliveryType', // 修改配送方式
  updateDeliveryAddress = '/manage/order/updateDeliveryAddress', // 修改收货地址

  queryOrderAllocateErrorRecordList = '/manage/orderAllocateError/queryOrderAllocateErrorRecordList', // 订单分佣异常补偿记录列表
  queryOrderAllocateErrorRecordCount = '/manage/orderAllocateError/queryOrderAllocateErrorRecordCount', // 订单分佣异常补偿记录 数量



  //物流相关
  queryExpressCompanyList = '/manage/express/company/queryExpressCompanyList',//快递公司列表
  queryExpressOrderList = '/manage/express/order/queryList', //物流订单列表查询
  kuaidi100SubscribePendingList = '/manage/express/kuaidi100/pendingList', // 快递100订阅失败列表
  kuaidi100RetrySubscribe = '/manage/express/kuaidi100/retrySubscribe', // 快递100重新订阅

  // 账单
  queryBillInfoList = '/manage/bill/queryBillInfoList', // 查询账单列表

  // 支付订单
  queryPayOrderByNo = '/manage/payOrder/queryPayOrderByNo', // 通过编号查询支付订单

  // 宣传页
  queryBrochureList = '/manage/brochure/queryBrochureList', // 查询宣传页
  queryBrochureById = '/manage/brochure/queryBrochureById', // 通过id查询宣传页
  createBrochure = '/manage/brochure/createBrochure', // 创建宣传页
  updateBrochure = '/manage/brochure/updateBrochure', // 更新宣传页
  deleteBrochure = '/manage/brochure/deleteBrochure', // 删除宣传页

  // 资讯
  queryInformationList = '/manage/information/queryInformationList', // 查询资讯
  queryInformationById = '/manage/information/queryInformationById', // 通过id查询资讯
  createInformation = '/manage/information/createInformation', // 创建资讯
  updateInformation = '/manage/information/updateInformation', // 更新资讯
  deleteInformation = '/manage/information/deleteInformation', // 删除资讯

  // 社区活动
  queryActivityInfoList = '/manage/activityInfo/queryActivityInfoList', // 查询社区活动列表
  queryActivityInfoByCode = '/manage/activityInfo/queryActivityInfoByCode', // 通过code查询社区活动
  createActivityInfo = '/manage/activityInfo/createActivity', // 创建社区活动
  updateActivityInfo = '/manage/activityInfo/updateActivity', // 更新社区活动
  deleteActivityInfo = '/manage/activityInfo/deleteActivity', // 删除社区活动
  queryActivityApplyList = '/manage/activityInfo/queryActivityApplyList', // 查询社区活动报名表

  // 供应商
  querySupplierList = '/manage/supplier/querySupplierList', // 查询供应商列表
  querySupplierInfoByCode = '/manage/supplier/querySupplierInfoByCode', // 通过code查询
  addSupplierInfo = '/manage/supplier/addSupplierInfo', // 添加供应商
  updateSupplierInfo = '/manage/supplier/updateSupplierInfo', // 修改供应商
  deleteSupplierInfo = '/manage/supplier/deleteSupplierInfo', // 删除供应商

  // banneer
  queryBannerList = '/manage/banner/queryBannerList', // 查询bannerlist
  addBanner = '/manage/banner/addBanner', // 添加banner
  changeBannersStatus = '/manage/banner/changeBannersStatus', // 修改顺序
  updateBanner = '/manage/banner/updateBanner', // 修改顺序
  deleteBanner = '/manage/banner/deleteBanner', // 修改顺序

  // 导航栏
  queryNavigationList = '/manage/navigation/queryNavigationList', // 查询导航栏列表
  createNavigation = '/manage/navigation/createNavigation', // 创建导航栏
  updateNavigation = '/manage/navigation/updateNavigation', // 修改导航栏
  deleteNavigation = '/manage/navigation/deleteNavigation', // 删除导航栏

  // 提货卷
  queryVoucherModelList= '/manage/voucherModel/queryVoucherModelList',
  queryVoucherModelById= '/manage/voucherModel/queryVoucherModelById',
  addVoucherModel= '/manage/voucherModel/addVoucherModel',
  updateVoucherModel= '/manage/voucherModel/updateVoucherModel',
  deleteVoucherModel= '/manage/voucherModel/deleteVoucherModel',
  updateVoucherModelStatus= '/manage/voucherModel/updateVoucherModelStatus',

  queryUserVoucherList= '/manage/userVoucher/queryUserVoucherList',
  queryUserVoucherById= '/manage/userVoucher/queryUserVoucherById',

  // 视频
  videoQueryList = '/api/manage/video/queryList',
  videoCreate = '/api/manage/video/create',
  videoEdit = '/api/manage/video/edit',
  videoDelete = '/api/manage/video/delete',
  videoQueryGoodsList = '/api/manage/video/queryGoodsList',
  deleteBindGoodds = '/api/manage/video/deleteBindGoodds',
  addBindGoodds = '/api/manage/video/addBindGoodds',

  // 店铺
  queryShopList = '/manage/shop/queryShopList',
  queryShopSpecialRefundEstimateSummary = '/manage/shop/queryShopSpecialRefundEstimateSummary',
  queryAllShopNameList = '/manage/shop/queryAllShopNameList',
  queryShopById = '/manage/shop/queryShopById',
  queryShopWealthDetail = '/manage/shop/queryShopWealthDetail',
  createShop = '/manage/shop/createShop',
  updateShop = '/manage/shop/updateShop',
  updateBaseShop = '/manage/shop/updateBaseShop',
  deleteShop = '/manage/shop/deleteShop',
  updateShopStatus = '/manage/shop/updateShopStatus',
  updateShopPlatformClose = '/manage/shop/updateShopPlatformClose',
  updateShopAuditStatus = '/manage/shop/updateShopAuditStatus',
  shopAuditPass = '/manage/shop/shopAuditPass',
  shopAuditRefuse = '/manage/shop/shopAuditRefuse',
  registSucccess = '/manage/shop/registSucccess',
  queryCurrentShop = '/manage/shop/queryCurrentShop',
  submitShopAuditStatus = '/manage/shop/submitShopAuditStatus',
  queryCurrentShopRegistMerchant = '/manage/shop/queryCurrentShopRegistMerchant',
  queryShopAddressList = '/manage/shopAddress/queryShopAddressList',
  registerShop = '/manage/shop/registerShop',
  queryShopRegistMerchantListById = '/manage/shop/queryShopRegistMerchantListById',
  openMerchantSucccess = '/manage/shop/openMerchantSucccess',
  huifuRegistMerchant = '/manage/shop/huifuRegistMerchant',
  queryMccList = '/manage/mcc/queryMccList',

  llpayOpenMerchant = '/manage/llpay/llpayOpenMerchant',
  getApplyPasswordElement = '/manage/llpay/getApplyPasswordElement',
  openacctActivateApply = '/manage/llpay/openacctActivateApply',
  openacctActivateVerify = '/manage/llpay/openacctActivateVerify',
  papAgreeApply = '/manage/llpay/papAgreeApply',
  openNoPwdWithdrawal = '/manage/llpay/openNoPwdWithdrawal',

  // 店铺流水
 queryShopWealthRecordList = '/manage/shop/queryShopWealthRecordList',
 exportShopWealthRecordList = '/manage/shop/exportShopWealthRecordList',


  // 药柜
  MCQueryList = '/manage/medicineCabinet/queryList',
  MCCreate = '/manage/medicineCabinet/create',
  MCUpdate = '/manage/medicineCabinet/update',
  MCUpdateStatus = '/manage/medicineCabinet/updateStatus',
  MCQueryStatusList = '/manage/medicineCabinet/queryStatusList',
  MCBindUser = '/manage/medicineCabinet/bindUser',
  MCQueryInvestorList = '/manage/medicineCabinet/queryInvestorList',

  // 投资人
  bindMedicineCabinet = '/api/manage/investor/bindMedicineCabinet',
  unbindMedicineCabinet = '/api/manage/investor/unbindMedicineCabinet',
  queryMedicineCabinetList = '/api/manage/investor/queryMedicineCabinetList',
  uploadIncomeFile = '/api/manage/investor/uploadIncomeFile',
  queryIncomeFileList = '/api/manage/investor/queryIncomeFileList',
  queryIncome = '/api/manage/investor/queryIncome',
  queryIncomeDetail = '/api/manage/investor/queryIncomeDetail',
  queryPlatformOperatingIncome = '/api/manage/investor/queryPlatformOperatingIncome',

  // 银行列表
  queryBankCodeList = '/manage/bankCode/queryBankCodeList',
  queryBankCodeById = '/manage/bankCode/queryBankCodeById',
  createBankCode = '/manage/bankCode/createBankCode',
  updateBankCode = '/manage/bankCode/updateBankCode',
  deleteBankCode = '/manage/bankCode/deleteBankCode',
  queryBankBranchList = '/manage/bankCode/queryBankBranchList',

  // 变更银行卡相关接口
  queryBankCardByShopId = '/manage/changeBankCard/queryBankCardByShopId',
  changeBankCardApply = '/manage/changeBankCard/changeBankCardApply',
  changeBankCardVerify = '/manage/changeBankCard/changeBankCardVerify',

  // 银行卡
  // 查询店铺银行卡列表
  queryShopBankCardList = '/manage/bankCard/queryShopBankCardList',
  createShopBankCard = '/manage/bankCard/createShopBankCard',
  deleteBankCard = '/manage/bankCard/deleteBankCard',

  // sysConfig
  queryConfigLIst = '/manage/sysConfig/queryConfigLIst',
  queryConfigById = '/manage/sysConfig/queryConfigById',
  addSysConfig = '/manage/sysConfig/addSysConfig',
  updateSysConfig = '/manage/sysConfig/updateSysConfig',
  removeSysConfig = '/manage/sysConfig/removeSysConfig',
  updateOrSaveSysConfigByParam = '/manage/sysConfig/updateOrSaveSysConfigByParam',

  // wechat ad reward
  syncWechatAdUnitList = '/manage/wechatAdReward/syncAdUnitList',
  queryWechatAdUnitList = '/manage/wechatAdReward/queryAdUnitList',
  queryWechatAdRewardConfig = '/manage/wechatAdReward/queryRewardConfig',
  saveWechatAdRewardConfig = '/manage/wechatAdReward/saveRewardConfig',

  couponTemplateList = '/manage/couponTemplate/list',
  couponTemplateSave = '/manage/couponTemplate/save',
  couponTemplateSetEnabled = '/manage/couponTemplate/setEnabled',
  couponGrant = '/manage/coupon/grant',
  couponVoidUserCoupon = '/manage/coupon/voidUserCoupon',
  couponGrantLogList = '/manage/coupon/grantLog/list',
  couponUserCouponList = '/manage/coupon/userCoupon/list',
  couponOpsOverview = '/manage/coupon/ops/overview',
  exportCouponGrantLogList = '/manage/coupon/grantLog/export',
  exportCouponUserCouponList = '/manage/coupon/userCoupon/export',
  exportUserPointsRecordList = '/manage/user/exportUserPointsRecordList',
  userCouponGrant = '/manage/userCoupon/grant',

  // user checkin config
  getUserCheckinConfig = '/manage/checkin/config/get',
  saveUserCheckinConfig = '/manage/checkin/config/save',
  listUserCheckinSpecialReward = '/manage/checkin/special/list',
  saveUserCheckinSpecialReward = '/manage/checkin/special/save',
  deleteUserCheckinSpecialReward = '/manage/checkin/special/delete',
  queryUserCheckinRecordList = '/manage/checkin/record/list',
  queryUserActivityRecordList = '/manage/activity/record/list',
  queryDayActivityLeaderboard = '/manage/activity/leaderboard/dayPage',
  getActivityDailyRankRewardConfig = '/manage/activityDailyRank/config/get',
  saveActivityDailyRankRewardConfig = '/manage/activityDailyRank/config/save',
  settleActivityDailyRankReward = '/manage/activityDailyRank/settle',

  //会员相关
  queryMemberList = "/manage/member/queryMemberList",
  creteMember = '/manage/member/createMember',
  updateMember = '/manage/member/updateMember',
  deleteMember = '/manage/member/deleteMember',
  updateMemberStatus = '/manage/member/updateStatus',
  queryMemberAllList = "/manage/member/queryAllList",
  queryMemberConfigList = '/manage/member/queryMemberConfigList',
  createMemberConfig = '/manage/member/createMemberConfig',
  updateMemberConfig = '/manage/member/updateMemberConfig',
  deleteMemberConfig = '/manage/member/deleteMemberConfig',
  updateMemberConfigStatus = '/manage/member/updateConfigStatus',

  //分红池相关
  queryDistributionActivityList = '/manage/distribution/queryDistributionActivityList',
  creteDistributionActivity = '/manage/distribution/createDistributionActivity',
  updateDistributionActivity = '/manage/distribution/updateDistributionActivity',
  updateDistributionActivityStatus = '/manage/distribution/updateStatus',

  //分红流水
  queryUserWealthRecordList = '/manage/user/queryUserWealthRecordList',
  exportUserWealthRecord = '/manage/user/exportUserWealthRecord',
  queryUserPointsRecordList = '/manage/user/queryUserPointsRecordList',
  queryDistributionActivityRecordList = '/manage/distribution/queryDistributionActivityRecordList',
  queryDistributionActivityUserRecordList = '/manage/distribution/queryDistributionActivityUserRecordList',

  // 提现
  queryWithdrawOrder = '/manage/withdraw/queryWithdrawOrder',
  queryWithdrawOrderById = '/manage/withdraw/queryWithdrawOrderById',
  refreshWithdrawOrder = '/manage/withdraw/refreshWithdrawOrder',
  exportWithdrawOrder = '/manage/withdraw/exportWithdrawOrder',
  queryShopWithdrawOrder = '/manage/withdraw/queryShopWithdrawOrder',
  applyWithdraw = '/manage/withdraw/applyWithdraw',
  firstApplyWithdrawPass = '/manage/withdraw/firstApplyWithdrawPass',
  applyWithdrawPass = '/manage/withdraw/applyWithdrawPass',
  withdrawValidationSms = '/manage/withdraw/withdrawValidationSms',
  applyWithdrawReject = '/manage/withdraw/applyWithdrawReject',
  queryShopBalance = '/manage/withdraw/queryShopBalance',

  createShopAddress = '/manage/shopAddress/createShopAddress',
  updateShopAddress = '/manage/shopAddress/updateShopAddress',
  deleteShopAddress = '/manage/shopAddress/deleteShopAddress',
  sumPlatformDataReport = '/manage/platform/sumPlatformDataReport',
  sumPlatformTotalData = '/manage/platform/sumPlatformTotalData',

  /**
   * 合伙人相关
   */
  queryPartnerList = "/manage/partner/queryPartnerList",
  createPartner = "/manage/partner/createPartner",
  updatePartner = "/manage/partner/updatePartner",
  deletePartner = "/manage/partner/deletePartner",
  queryPartnerAllList = "/manage/partner/queryAllList",

  /**
   * 公告相关
   */
queryAnnouncementList='/manage/announcement/queryAnnouncementList',
createAnnouncement='/manage/announcement/createAnnouncement',
updateAnnouncement='/manage/announcement/updateAnnouncement',
deleteAnnouncement='/manage/announcement/deleteAnnouncement',

  /**
   * 发票类型相关
   */
queryInvoiceTypeList='/manage/invoiceType/queryInvoiceTypeList',
queryAllInvoiceTypeList='/manage/invoiceType/queryAllInvoiceTypeList',
createInvoiceType='/manage/invoiceType/createInvoiceType',
updateInvoiceType='/manage/invoiceType/updateInvoiceType',
deleteInvoiceType='/manage/invoiceType/deleteInvoiceType',


  /**
   *文章相关
   */
queryNewsList='/manage/news/queryNewsList',
createNews='/manage/news/createNews',
updateNews='/manage/news/updateNews',
deleteNews='/manage/news/deleteNews',

  /** 首页配置 */
  queryIndexHomeConfig = '/manage/index/queryHomeConfig',
  updateIndexHomeConfig = '/manage/index/updateHomeConfig',

  /** 产地故事 */
  queryOriginStoryList = '/manage/originStory/queryOriginStoryList',
  createOriginStory = '/manage/originStory/createOriginStory',
  updateOriginStory = '/manage/originStory/updateOriginStory',
  deleteOriginStory = '/manage/originStory/deleteOriginStory',

queryManageCommentList='/manage/comment/queryCommentList',
updateCommentDisplayStatus='/manage/comment/updateCommentDisplayStatus',

queryWealthRecordList = '/manage/platform/queryWealthRecordList',
  queryWealthRecordSummary = '/manage/platform/queryWealthRecordSummary',
exportWealthRecord = '/manage/platform/exportWealthRecord',

/**
 * 店铺余额支付记录
 */
queryShopBalanceRecordList = '/manage/shopBalance/queryShopBalanceRecordList',
exportShopBalanceRecord = '/manage/shopBalance/exportShopBalanceRecord',
shopBalancePay = '/manage/shopBalance/shopBalancePay',

queryMemberAddressConfigList = '/manage/memberAddressConfig/queryList',
createMemberAddressConfig = '/manage/memberAddressConfig/createMemberAddressConfig',
updateMemberAddressConfig = '/manage/memberAddressConfig/updateMemberAddressConfig',
deleteMemberAddressConfig = '/manage/memberAddressConfig/deleteMemberAddressConfig',

/**
 * 操作日志
 */
queryLogList = '/manage/sysOperLog/queryLogList',
exportOperLog = '/manage/sysOperLog/exportOperLog',
deleteOperLog = '/manage/sysOperLog/deleteOperLog',
clearAllOperLog = '/manage/sysOperLog/clearAllOperLog',

/**
 * 统计分析
 */
queryFinanceIndexData = '/manage/statistical/queryFinanceIndexData',
queryDailySalesStatList = '/manage/statistical/queryDailySalesStatList',
exportDailySalesStat = '/manage/statistical/exportDailySalesStat',
queryEnergyContributionStatList = '/manage/statistical/queryEnergyContributionStatList',
exportEnergyContributionStat = '/manage/statistical/exportEnergyContributionStat',
queryMengBeanSummaryList = '/manage/statistical/queryMengBeanSummaryList',
exportMengBeanSummary = '/manage/statistical/exportMengBeanSummary',
queryPlatformPvSummaryList = '/manage/statistical/queryPlatformPvSummaryList',
  manualAdjustPlatformPv = '/manage/platformWealth/manualAdjustPv', // 平台总PV手工调账
  previewMixedPayRelease = '/manage/payOrder/previewMixedPayRelease', // 混合抵扣异常预览
  handleMixedPayRelease = '/manage/payOrder/handleMixedPayRelease', // 混合抵扣异常确认处理
exportPlatformPvSummary = '/manage/statistical/exportPlatformPvSummary',
queryWithdrawMerchantBalanceStatList = '/manage/statistical/queryWithdrawMerchantBalanceStatList',
  exportWithdrawMerchantBalanceStat = '/manage/statistical/exportWithdrawMerchantBalanceStat',
  queryFinanceSalesStatList = '/manage/statistical/queryFinanceSalesStatList',
  exportFinanceSalesStat = '/manage/statistical/exportFinanceSalesStat',
  queryFinanceMungBeanStatList = '/manage/statistical/queryFinanceMungBeanStatList',
  exportFinanceMungBeanStat = '/manage/statistical/exportFinanceMungBeanStat',
  queryFinanceBizReconcileIndexData = '/manage/statistical/queryFinanceBizReconcileIndexData',
  queryFinanceAllocateRechargeDailyStatList = '/manage/statistical/queryFinanceAllocateRechargeDailyStatList',
  exportFinanceAllocateRechargeDailyStat = '/manage/statistical/exportFinanceAllocateRechargeDailyStat',
  queryFinanceSpecialPriceDailyStatList = '/manage/statistical/queryFinanceSpecialPriceDailyStatList',
  exportFinanceSpecialPriceDailyStat = '/manage/statistical/exportFinanceSpecialPriceDailyStat',
  queryFinanceDistributionDailyStatList = '/manage/statistical/queryFinanceDistributionDailyStatList',
  exportFinanceDistributionDailyStat = '/manage/statistical/exportFinanceDistributionDailyStat',
  queryFinanceBizPvReconcileDailyStatList = '/manage/statistical/queryFinanceBizPvReconcileDailyStatList',
  exportFinanceBizPvReconcileDailyStat = '/manage/statistical/exportFinanceBizPvReconcileDailyStat',
  regenerateFinanceBizReconcileStat = '/manage/statistical/regenerateFinanceBizReconcileStat',
  queryFinanceWealthWayDailyIndexData = '/manage/statistical/queryFinanceWealthWayDailyIndexData',
  queryFinanceWealthWayDailyList = '/manage/statistical/queryFinanceWealthWayDailyList',
  exportFinanceWealthWayDaily = '/manage/statistical/exportFinanceWealthWayDaily',
  queryFinanceAssetDailyBalanceList = '/manage/statistical/queryFinanceAssetDailyBalanceList',
  exportFinanceAssetDailyBalance = '/manage/statistical/exportFinanceAssetDailyBalance',
  regenerateFinanceWealthWayDailyStat = '/manage/statistical/regenerateFinanceWealthWayDailyStat',
  queryFinanceWealthWayDailyCategoryGroup = '/manage/statistical/queryFinanceWealthWayDailyCategoryGroup',
  queryFinanceAsOfStat = '/manage/statistical/queryFinanceAsOfStat',

// 特殊关单退绿豆
shopSpecialRefundPreview = '/manage/shopSpecialRefund/preview',
shopSpecialRefundExecute = '/manage/shopSpecialRefund/execute',
shopSpecialRefundPreviewExecuteItem = '/manage/shopSpecialRefund/previewExecuteItem',
shopSpecialRefundPreviewRollback = '/manage/shopSpecialRefund/previewRollback',
shopSpecialRefundRollback = '/manage/shopSpecialRefund/rollback',
shopSpecialRefundQueryBatch = '/manage/shopSpecialRefund/queryBatch',
exportShopSpecialRefundPreviewExcel = '/manage/shopSpecialRefund/exportPreviewExcel',
exportShopSpecialRefundResultExcel = '/manage/shopSpecialRefund/exportResultExcel',
exportShopSpecialRefundRollbackExcel = '/manage/shopSpecialRefund/exportRollbackExcel',
shopSpecialRefundListBatch = '/manage/shopSpecialRefund/listBatch',
shopSpecialRefundQueryBatchItemDetail = '/manage/shopSpecialRefund/queryBatchItemDetail',
shopSpecialRefundListUserLogByBatch = '/manage/shopSpecialRefund/listUserLogByBatch',
shopSpecialRefundListUserLogByUser = '/manage/shopSpecialRefund/listUserLogByUser',
shopSpecialRefundQueryLossAnalysis = '/manage/shopSpecialRefund/queryLossAnalysis',
shopSpecialRefundQueryPlatformLossAnalysis = '/manage/shopSpecialRefund/queryPlatformLossAnalysis',
shopSpecialRefundListExecSuccess = '/manage/shopSpecialRefund/listExecSuccess',
shopSpecialRefundListOperateLog = '/manage/shopSpecialRefund/listOperateLog',
exportShopSpecialRefundExecSuccessExcel = '/manage/shopSpecialRefund/exportExecSuccessExcel',

// 用户会员
queryUserMemberChangeRecordList = '/manage/userMember/queryUserMemberChangeRecordList',
queryUserMemberChangeRecordById = '/manage/userMember/queryUserMemberChangeRecordById',


}


export default API;
